
// common.js
// Add any common javascript functions that are needed for this app
// Currently it's only imported in store/index.js file 
// In the future if we need to include this file in multiple components - we can import this into main.js
var commonJs = {
    subtractMonths(date, months) {
        var result = new Date(date), 
            expectedMonth = ((date.getMonth() - months) % 12 + 12) % 12;
            
        result.setMonth(result.getMonth() - months);
        if (result.getMonth() !== expectedMonth) {
            result.setDate(0);
        }
        return result;
    },
    reformatNumber(num) {
        // Handle negative numbers
        if (num.length > 0) {
            if (num.charAt(0) === "-") {
                num = "(" + num.substr(1) + ")";
            }
        }
        return num;
    }
}

export default commonJs;